export default __webpack_public_path__ + "static/media/hht1_ep20_timeline_q02_b.9925aaa1.png";